import { Trans } from '@lingui/macro';
import React, { FC, useState, useEffect } from 'react'
import { Carousel } from 'react-bootstrap';
import { BallTriangle } from 'react-loader-spinner';
import ReactQuill from 'react-quill';
import { Link, useParams } from 'react-router-dom';
import { isEmpty } from 'underscore';
import EventsService from '../../services/EventsService';


export const EventPage: FC = () => {
    const { eventId } = useParams();
    const [data, setData] = useState<any>({});
    const [loader, setLoader] = useState<boolean>(false);

    const date = isEmpty(data) ? '' : data['create_date'].split('T');
    const formattedDate = date === '' ? '' : date[0].split('-');

    const getEvent = async () => {
        try {
            const res = await EventsService.getEvent(Number(eventId));
            setData(res.data);
            setLoader(false);
        } catch (e) {
            setData({ id: eventId, header: '', create_date: '', author: '', text: 'Страница не найдена' });
            setLoader(false);
        }
    }
    // var htmlObject = document.createElement('div');
    // htmlObject.innerHTML = data['text'];
    useEffect(() => {
        setLoader(true);
        getEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventId]);

    const [images, setImages] = useState<any[]>([]);

    const getImages = () => {
        let imgMass = []
        if (!isEmpty(data)) {
            for (let i = 2; i < 10; i++) {
                if (data[`image${i}`]) {
                    imgMass.push(data[`image${i}`]);
                }
            };
        }
        setImages(imgMass);
    };

    useEffect(() => {
        getImages();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    return (loader ? <div className='row justify-content-center'><div className='col-md-2 mt-5'><BallTriangle color="#1d7ea7" height={90} width={90} /></div></div> :
        <div className="row m-3">
            <div>
                <Link to={`/`}><button className="btn btn-light" ><i className="icon arrow-left"></i><Trans>Back</Trans></button></Link>
            </div>
            <div className="text-end">
                {data['author'] ? <p>Автор: {data['author']}</p> : null}
                {data['create_date'] ? <p><Trans>Publication date</Trans>: {formattedDate[2]}.{formattedDate[1]}.{formattedDate[0]}</p> : null}
            </div>
            <h3 className="event-header text-center">{isEmpty(data) ? '' : data['header']}</h3>
            <ReactQuill
                value={data['text']}
                className='react-quill'
                readOnly={true}
                theme={"bubble"}
            />
            <hr />
            {!isEmpty(images) ?
                <div className="row justify-content-center">
                    <h5><Trans>Photo Collection</Trans></h5>
                    <div className="col-md-7">
                        <Carousel>
                            {images.map((url, i) => {
                                return (
                                    <Carousel.Item key={i}>
                                        <img
                                            className="d-block w-100"
                                            src={url}
                                            alt={`фото${i}`}
                                        />

                                    </Carousel.Item>
                                )
                            })}
                        </Carousel>
                    </div>
                </div>
                : null}
        </div>

    );
};